// import React from "react";
// import SideBar from "./SideBar";

// export default function AppLayout({ children }) {
//   return (
//     <div className="flex h-screen">
//       <SideBar />
//       <main className="flex-1 relative bg-[#f5f7fa]">
//         {children}
//       </main>
//     </div>
//   );
// }

import React from "react";
//import SideBar from "./SideBar";

export default function AppLayout({ children }) {
  return (
    <div className="flex min-h-screen bg-[#FAFAF6]">
      {/* <SideBar /> */}
      <main className="flex-1 flex flex-col items-center justify-center bg-[#FAFAF6]">
        {children}
      </main>
    </div>
  );
}
